import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import { formatVal, isInValidValue } from '../../../../../../helpers/value'

const Chart = ({ data, propsChart, isDynamicReport }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className="h100 flexColumn">
      <div className="fw600 pb1">
        <Translate value={propsChart.title} />
      </div>
      <ChartContainer
        data={data}
        width="100%"
        height="100%"
        margin={{ top: 5, bottom: 0, left: 0, right: 0 }}
        xAxis={[
          {
            dataKey: 'year',
            tickMargin: 3,
            height: 20,
            type: 'category',
            tickFormatter: (year) => '‘' + String(year).slice(2, 4),
          },
        ]}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: [propsChart.dataKey],
            isBarChart: true,
          },
        ]}
        tooltip={{
          cursor: false,
          schema: {
            content: [
              {
                dataKey: propsChart.dataKey,
                label: propsChart.label,
                formatValue: (value) => formatVal(value, locale),
              },
            ],
          },
        }}
      >
        <Bar
          yAxisId="left"
          dataKey={propsChart.dataKey}
          fill="transparent"
          label={<CustomizedLabel fill={propsChart.color} />}
          showLabelEmpty={() => {
            return false
          }}
        />
      </ChartContainer>
    </div>
  )
}

const CustomizedLabel = (props) => {
  const {
    x,
    y,
    width,
    fill,
    index,
    value,
    barProps: { data },
  } = props

  const background = data[index].background

  if (isInValidValue(value)) {
    return (
      <line
        x1={background.x + background.width / 2}
        y1={background.y}
        x2={background.x + background.width / 2}
        y2={background.y + background.height}
        stroke={fill}
      />
    )
  }

  return (
    <>
      <line
        x1={background.x + background.width / 2}
        y1={background.y}
        x2={background.x + background.width / 2}
        y2={background.y + background.height}
        stroke={fill}
      />
      <circle cx={x + width / 2} cy={y} r="4" fill={fill} />
    </>
  )
}

export default Chart
